import { render, staticRenderFns } from "./Tagihan.vue?vue&type=template&id=27b415f9&"
import script from "./Tagihan.vue?vue&type=script&lang=js&"
export * from "./Tagihan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports